module.exports = __webpack_public_path__ + "img/drop.24857bf2.svg";